module.exports = __webpack_public_path__ + "media/images/emblems/Arnex-sur-Orbe-coat_of_arms-84b940f71e8a9addcf39e5fd585490a7.svg";